<script setup>
defineOptions({
  name: 'MapSidebar',
})

// const isOpen = ref(true)
</script>

<template>
  <div class="bg-grey-50 inset-y-0 w-full absolute md:right-0 md:max-w-sm xl:relative xl:max-w-md p-4 overflow-y-auto">
    <slot />
  </div>

  <!-- <div class="relative w-1 z-sidebar">
    <div
      class="absolute inset-y-0 -right-full z-sidebar w-full max-w-md bg-grey-50 transition-all overflow-y-auto"
      :class="{
        'right-0!': isOpen,
      }"
    >
      <DIconButton
        class="absolute top-1/2 -left-4 z-hop -mt-4"
        size="sm"
        :path="`chevron-${isOpen ? 'right' : 'left'}`"
        variant="fill-primary"
        @click="isOpen = !isOpen"
      />

      <slot />
    </div>
  </div> -->
</template>
